import React from 'react';
import { FadeInUp, SectionLabelLight, AccentLineLight, StaggerContainer, StaggerItem, AnimatedCounter } from './AnimationWrappers';

const METRICS = [
  { value: '800', label: 'Machines (New Plant)' },
  { value: '1200', label: 'Workers (Full Capacity)' },
  { value: '140000', label: 'Sq. Ft. Built-Up Area' },
  { value: '4.5', label: 'km From Current Facility' },
];

const NextChapterSection = () => {
  return (
    <section id="next-chapter" data-testid="next-chapter-section" className="relative overflow-hidden" style={{ background: '#1C1C1E', padding: '70px 0' }}>
      {/* Decorative "2027" text */}
      <div className="absolute right-8 top-1/2 -translate-y-1/2 font-display pointer-events-none" style={{ fontSize: '280px', fontWeight: 700, color: 'rgba(255,255,255,0.03)' }}>2027</div>

      <div className="container-main relative z-10">
        <SectionLabelLight number="02" title="The Next Chapter" />
        <FadeInUp>
          <AccentLineLight />
        </FadeInUp>

        <div className="grid grid-cols-1 lg:grid-cols-2 items-start" style={{ gap: '70px' }}>
          <div>
            <FadeInUp>
              <h2 className="font-display text-white mb-6" style={{ fontSize: '2.8rem', fontWeight: 700 }}>
                Building the <span style={{ color: '#C8102E' }}>future.</span>
              </h2>
            </FadeInUp>
            <FadeInUp delay={0.1}>
              <p className="font-body mb-8" style={{ fontSize: '1.1rem', fontWeight: 300, color: 'rgba(255,255,255,0.7)', lineHeight: 1.85 }}>
                Just 4.5 km from our current facility, we're investing in a new, purpose-built manufacturing campus that will triple our workforce capacity and position Qualiance to handle the largest international programs.
              </p>
            </FadeInUp>
            <FadeInUp delay={0.2}>
              {/* Expansion badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full" style={{ border: `1px solid ${`#B87333`}` }}>
                <span className="font-mono" style={{ fontSize: '0.72rem', color: '#B87333', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
                  Construction Slated to Be Ready — January 2027
                </span>
              </div>
            </FadeInUp>
          </div>

          {/* Stat cards */}
          <StaggerContainer className="grid grid-cols-2 gap-4">
            {METRICS.map((m, i) => (
              <StaggerItem key={i}>
                <div
                  data-testid={`next-chapter-metric-${i}`}
                  className="transition-all duration-300 hover:border-[#C8102E]"
                  style={{
                    background: 'rgba(255,255,255,0.05)',
                    borderLeft: '3px solid #B87333',
                    padding: '20px',
                    borderRadius: '4px',
                  }}
                >
                  <span className="font-display block text-white mb-1" style={{ fontSize: '2.4rem', fontWeight: 700 }}>
                    <AnimatedCounter target={m.value} />
                  </span>
                  <span className="font-mono" style={{ fontSize: '0.6rem', color: 'rgba(255,255,255,0.45)', textTransform: 'uppercase', letterSpacing: '0.12em' }}>{m.label}</span>
                </div>
              </StaggerItem>
            ))}
          </StaggerContainer>
        </div>
      </div>
      <div className="section-number" style={{ color: 'rgba(255,255,255,0.03)' }}>02</div>
    </section>
  );
};

export default NextChapterSection;
